import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
    setSearchedLayer,
    setScrollingToSearchedLayer
} from '../../../../redux/panel/search_panel/Actions';

import {
    Typography,
    Collapse
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import AdditionalLayerDropdownRow from './AdditionalLayerDropdownRow';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

class AdditionalLayerDropdownItem extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            droppedDown: false
        };

        this.toggleDropdown = this.toggleDropdown.bind(this);
    }

    selectedLayerIncluded () {
        const { layers, selectedLayer } = this.props;
        return layers.map(l => l.system_name).filter(l => l === selectedLayer.systemName).length > 0;
    }

    isCheckboxIndeterminate (layerSystemNames) {
        const { activeLayers } = this.props;
        const length = activeLayers
            .filter((layer) => layerSystemNames.includes(layer.uid))
            .filter((layer) => layer.visible).length;
        return (length > 0) && (length !== layerSystemNames.length);
    }

    allLayersSelected (layerSystemNames) {
        const { activeLayers } = this.props;
        const length = activeLayers
            .filter((layer) => layerSystemNames.includes(layer.uid))
            .filter((layer) => layer.visible).length;
        return length === layerSystemNames.length;
    }

    toggleDropdown (e) {
        const { dispatchSetSearchedLayer } = this.props;
        const { droppedDown } = this.state;
        if (this.selectedLayerIncluded()) {
            dispatchSetSearchedLayer({ category: '', systemName: '' });
            this.setState({
                droppedDown: false
            });
        } else {
            this.setState({
                droppedDown: !droppedDown
            });
        }
    }

    render () {
        const {
            classes,
            layers,
            activeLayers,
            group
        } = this.props;
        const { droppedDown } = this.state;
        return (
            <div className={classnames(classes.groupContainer, droppedDown && classes.groupContainerSelected)} id={group.replaceAll(' ', '-')}>
                <div
                    className={classes.groupItem}
                    onClick={this.toggleDropdown}
                >
                    <div className={classes.groupItemTitle}>
                        <Typography
                            variant="body1"
                            color="textPrimary"
                            className={classes.additionalLayersButtonTitleText}
                        >
                            { group }
                        </Typography>
                    </div>

                    <div className={classes.additionalLayersButtonCheckbox}>
                        <ArrowDropDownIcon
                            className={`${classes.dropDownArrow} ${(droppedDown || this.selectedLayerIncluded()) && classes.dropDownArrowOpen}`}
                        />
                    </div>
                </div>
                <Collapse
                    className={classes.layerRows}
                    in={droppedDown || this.selectedLayerIncluded()}
                    timeout="auto"
                    unmountOnExit
                >
                    { layers.map((layer, j) => {
                        const activeLayer = activeLayers.find(
                            active_layer => active_layer.uid === layer.system_name
                        );
                        return <AdditionalLayerDropdownRow layer={layer} activeLayer={activeLayer} classes={classes} key={j} />;
                    }) }
                </Collapse>
            </div>
        );
    }
}

const styles = (theme) => ({
    additionalLayersButtonTitleText: {
        alignSelf: 'center'
    },
    additionalLayersButtonCheckbox: {
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center'
    },
    layerListHR: {
        width: '90%'
    },
    layerItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '6px 12px',
        '& > *:not(:first-child)': {
            marginLeft: 12
        }
    },
    '@keyframes notify': {
        '0%': {
            background: theme.palette.primary.main
        },
        '100%': {
            background: 'transparent'
        }
    },
    highlighted: {
        animation: '$notify 5s'
    },
    layerItemTitleText: {
        // fontSize: '0.8rem'
    },
    addLayersToFavouriteButtonContainer: {
        padding: '20px 5px'
    },
    addLayersToFavouriteButton: {
        fontSize: '12px',
        width: '100%',
        padding: '8px'
    },
    groupContainer: {
        borderTop: `1px solid ${theme.palette.background.border}`,
        '&:first-child': {
            borderTop: 'none'
        }
    },
    groupItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.constants.verticalMargin,
        cursor: 'pointer'
    },
    layerRows: {
        padding: '6px 0px',
        borderTop: `1px solid ${theme.palette.background.border}`
    },
    dropDownArrow: {
        alignSelf: 'center',
        transform: 'rotate(0deg)',
        transition: 'transform 0.2s linear',
        color: theme.palette.icon.main
    },
    dropDownArrowOpen: {
        transform: 'rotate(180deg)',
        transition: 'transform 0.2s linear'
    }
});

const mapStateToProps = (state) => {
    return {
        activeLayers: state.activeLayers,
        selectedLayer: state.search_panel.selectedLayer
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchSetSearchedLayer: ({ category, systemName }) => dispatch(setSearchedLayer({ category, systemName })),
        dispatchSetScrollingToSearchedLayer: (value) => dispatch(setScrollingToSearchedLayer(value))
    };
};

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(AdditionalLayerDropdownItem);